import React, { useEffect, useRef, useState } from "react";
import "./Services.css";
import ServiceCard from "../../Reusable/ServiceCard/ServiceCard";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ArrowDownRightIcon } from "@heroicons/react/24/solid";
import letsTravel from "../../Asset/letsTravel.jpeg";
import letsTravel_quote from "../../Asset/letsTravel_quote.png";
import visit from "../../Asset/visit1.jpeg";
import visit2 from "../../Asset/visit2.jpeg";
import visit3 from "../../Asset/visit3.jpeg";
import visit4 from "../../Asset/visit4.jpeg";
import visit5 from "../../Asset/visit5.jpeg";
const Services = () => {
  const triggerRef = useRef(null);
  const sectionRef = useRef(null);
  gsap.registerPlugin(ScrollTrigger);

  var scrollData = "";
  function getScrollData() {
    console.log(scrollData);
    if (window.innerWidth >= 1200) {
      scrollData = "-190vw";
    } else if (window.innerWidth >= 600) {
      scrollData = "-310vw";
    } else {
      scrollData = "-510vw";
    }
  }
  useEffect(() => {
    getScrollData();
  }, [window.innerWidth]);
  useEffect(() => {
    const pin = gsap.fromTo(
      sectionRef.current,
      {
        translateX: 0,
      },
      {
        // translateX: { scrollData },
        // translateX: "-510vw", --mob
        // translateX: "-310vw", --tab
        translateX: scrollData,
        // xPercent: -100 * (sections.length - 1),

        ease: "none",
        // duration: 1,
        scrollTrigger: {
          trigger: triggerRef.current,
          // start: "top -4%",
          //   end: "2000 top",
          scrub: 3,
          pin: true,
        },
      }
    );

    return () => {
      pin.kill();
    };
  }, []);

  return (
    <div className="Wrapper">
      <div ref={triggerRef}>
        <div ref={sectionRef} className="ServiceContainer">
          <div className="letsTravel">
            <div className="letsTravel_left">
              <img src={letsTravel_quote} alt="" />
            </div>
            <div className="letsTravel_Right">
              <img src={letsTravel} alt="" />
            </div>
          </div>
          <div className="Visit">
            <div className="VisitContainer">
              <h1>BEAUTIFUL GREECE</h1>
              <button>EXPLORE</button>
              <marquee
                className="marqueehContainer"
                scrollamount="12"
                width="100%"
                direction="right"
              >
                <h1 className="marqueeh1">BEAUTIFUL GREECE</h1>
              </marquee>
            </div>
            <img src={visit} alt="" />
          </div>
          <div className="Visit_place">
            <div className="visitPlaceContainer">
              <img src={visit2} alt="" />
              <div className="VisitPlaceDetails">
                <h3>Romantic</h3>
                <h1>Wine Tour</h1>
              </div>
            </div>
            <div className="visitPlaceContainer">
              <img src={visit3} alt="" />
              <div className="VisitPlaceDetails">
                <h3>Active</h3>
                <h1>Hiking</h1>
              </div>
            </div>
            <div className="visitPlaceContainer">
              <img src={visit4} alt="" />
              <div className="VisitPlaceDetails">
                <h3>Destinations</h3>
                <h1>Exotic Places</h1>
              </div>
            </div>
            <div className="visitPlaceContainer">
              <img src={visit5} alt="" />
              <div className="VisitPlaceDetails">
                <h3>Relaxing</h3>
                <h1>Holiday</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
